export const SET_RELEASE_NOTES_DATA = "SET_RELEASE_NOTES_DATA";
export const ADD_RELEASE_NOTE = "ADD_RELEASE_NOTE";
export const UPDATE_RELEASE_NOTE = "UPDATE_RELEASE_NOTE";
export const DELETE_RELEASE_NOTE = "DELETE_RELEASE_NOTE";
